/* eslint-disable no-inner-declarations */
export default class QuantitySpinnerInput {
  constructor(app, callback) {
    this.app = app;
    this.callback = callback;

    this.init = this.init.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleMinusClick = this.handleMinusClick.bind(this);
    this.handlePlusClick = this.handlePlusClick.bind(this);

    this.init();
  }

  init() {
    // Attach event listener to a parent element that remains constant in the DOM
    document.addEventListener('click', this.handleClick, false);
  }

  handleClick(event) {
    const targetElement = event.target;

    // Check if the clicked element is a plus or minus button within a spinner element
    if (targetElement.classList.contains('plus')) {
      this.handlePlusClick(targetElement);
    } else if (targetElement.classList.contains('minus')) {
      this.handleMinusClick(targetElement);
    }
  }

  handlePlusClick(targetElement) {
    // Get the spinner element associated with the clicked plus button
    const spinnerElement = targetElement.closest('.js-quantity-spinner-input');
    if (!spinnerElement) return;

    // Get the input element within the spinner element
    const qtyElement = spinnerElement.querySelector('.qty');

    // Get the current value, step and max attributes of the input element
    const currentValue = parseFloat(qtyElement.value);
    const step = parseFloat(qtyElement.getAttribute('step'));
    const max = parseFloat(qtyElement.getAttribute('max'));

    // If the max attribute is set and the current value is equal to or greater than the max value, do nothing
    const newValue = max && max <= currentValue ? max : currentValue + step;
    qtyElement.value = newValue;

    // Trigger the callback function, such as updating the cart
    if (this.callback) this.callback();
  }

  handleMinusClick(targetElement) {
    // Get the spinner element associated with the clicked minus button
    const spinnerElement = targetElement.closest('.js-quantity-spinner-input');
    if (!spinnerElement) return;

    // Get the input element within the spinner element
    const qtyElement = spinnerElement.querySelector('.qty');

    // Get the current value, step and min attributes of the input element
    const currentValue = parseFloat(qtyElement.value);
    const step = parseFloat(qtyElement.getAttribute('step'));
    const min = parseFloat(qtyElement.getAttribute('min'));

    // If the min attribute is set and the current value is equal to or less than the min value, do nothing
    const newValue = min && min >= currentValue ? min : currentValue - step;
    qtyElement.value = newValue;

    // Trigger the callback function, such as updating the cart
    if (this.callback) this.callback();
  }

  destroy() {
    // Remove event listener from the parent element
    document.removeEventListener('click', this.handleClick, false);
  }
}



// WEBPACK FOOTER //
// ./scripts/components/quantitySpinnerInput.js